import script from "./LoadRolesMixin.vue?vue&type=script&lang=js"
export * from "./LoadRolesMixin.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__